/* eslint-disable no-template-curly-in-string */
const AG_GRID_LOCALE_FI = {
  // Set Filter
  selectAll: '(Valitse kaikki)',
  selectAllSearchResults: '(Valitse kaikki hakutulokset)',
  searchOoo: 'Haet...',
  blanks: '(Tyhjät)',
  noMatches: 'Ei osumia',

  // Number Filter & Text Filter
  filterOoo: 'Suodata...',
  equals: 'Yhtä kuin',
  notEqual: 'Eri suuri',
  blank: 'Tyhjä',
  notBlank: 'Ei-tyhjä',
  empty: 'Valitse yksi',

  // Number Filter
  lessThan: 'Pienempi kuin',
  greaterThan: 'Suurempi kuin',
  lessThanOrEqual: 'Pienempi tai yhtä suuri kuin',
  greaterThanOrEqual: 'Suurempi tai yhtä suuri kuin',
  inRange: 'Välillä',
  inRangeStart: 'alkaen',
  inRangeEnd: 'loppuen',

  // Text Filter
  contains: 'Sisältää',
  notContains: 'Ei sisällä',
  startsWith: 'Alkaa',
  endsWith: 'Loppuu',

  // Date Filter
  dateFormatOoo: 'dd-mm-yyyy',

  // Filter Conditions
  andCondition: 'JA',
  orCondition: 'TAI',

  // Filter Buttons
  applyFilter: 'Aseta',
  resetFilter: 'Resetoi',
  clearFilter: 'Tyhjennä',
  cancelFilter: 'Peru',

  // Filter Titles
  textFilter: 'Tekstisuodatin',
  numberFilter: 'Numerosuodatin',
  dateFilter: 'Päivämääräsuodatin',
  setFilter: 'Aseta suodatin',

  // Group Column Filter
  groupFilterSelect: 'Valitse kenttä:',

  // Side Bar
  columns: 'sarakkeet',
  filters: 'Suodattimet',

  // columns tool panel
  pivotMode: 'Pivot-tila',
  groups: 'Rivin ryhmittely',
  rowGroupColumnsEmptyMessage:
    'Raahaa tänne asettaaksesi rivin ryhmittely',
  values: 'Arvot',
  valueColumnsEmptyMessage: 'Raahaa tänne ryhmitelläksesi',
  pivots: 'saraken nimike',
  pivotColumnsEmptyMessage:
    'Raahaa tänne asettaaksesi saraken nimike',

  // Header of the Default Group Column
  group: 'Ryhmä',

  // Row Drag
  rowDragRow: 'rivi',
  rowDragRows: 'rivit',

  // Other
  loadingOoo: 'Ladataan...',
  loadingError: 'VIRHE',
  noRowsToShow: 'Ei rivejä näytettäväksi',
  enabled: 'Sallittu',

  // Menu
  pinColumn: 'Kiinnitä sarake',
  pinLeft: 'Kiinnitä vasemmalle',
  pinRight: 'Kiinnitä oikealle',
  noPin: 'Ei kiinnitystä',
  valueAggregation: 'Arvon koonti',
  noAggregation: 'Ei mikään',
  autosizeThiscolumn: 'Autosovita tämä sarake',
  autosizeAllColumns: 'Autosovita kaikki sarakkeet',
  groupBy: 'Ryhmittele käyttäen',
  ungroupBy: 'Poista ryhmittely käyttäen',
  addToValues: 'Lisää ${muuttuja} arvoihin',
  removeFromValues: 'Poista ${muuttuja} arvoista',
  addToLabels: 'Lisää ${muuttuja} nimikkeisiin',
  removeFromLabels: 'Poista ${muuttuja} nimikkeistä',
  resetColumns: 'Resetoi sarakkeet',
  expandAll: 'Laajenna kaikki',
  collapseAll: 'Sulje kaikki',
  copy: 'Kopioi',
  ctrlC: 'Ctrl+C',
  copyWithHeaders: 'Kopioi otsikoiden kanssa',
  copyWithGroupHeaders: 'Kopioi ryhmäotsikoiden kanssa',
  cut: 'Leikkaa',
  paste: 'Liitä',
  ctrlV: 'Ctrl+V',
  export: 'Vienti',
  csvExport: 'CSV-vienti',
  excelExport: 'Excel-vienti',

  // Enterprise Menu Aggregation and Status Bar
  sum: 'Summa',
  first: 'Ensimmäinen',
  last: 'Viimeinen',
  min: 'Minimi',
  max: 'Maximi',
  none: 'Ei mikään',
  count: 'Määrä',
  avg: 'Keskiarvo',
  filteredRows: 'Suodatetut',
  selectedRows: 'Valitut',
  totalRows: 'Yhteensä rivejä',
  totalAndFilteredRows: 'Rivejä',
  more: 'Lisää',
  to: 'johokin',
  of: 'jostakin',
  page: 'Sivu',
  nextPage: 'Seuraava sivu',
  lastPage: 'Viimenen sivu',
  firstPage: 'Ensimmäinen sivu',
  previousPage: 'Aiempi sivu',

  // Pivoting
  pivotColumnGroupTotals: 'Yhteensä',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
  pivotChart: 'Pivot Chart',
  chartRange: 'Chart Range',

  columnChart: 'Column',
  groupedColumn: 'Grouped',
  stackedColumn: 'Stacked',
  normalizedColumn: '100% Stacked',

  barChart: 'Bar',
  groupedBar: 'Grouped',
  stackedBar: 'Stacked',
  normalizedBar: '100% Stacked',

  pieChart: 'Pie',
  pie: 'Pie',
  doughnut: 'Doughnut',

  line: 'Line',

  xyChart: 'X Y (Scatter)',
  scatter: 'Scatter',
  bubble: 'Bubble',

  areaChart: 'Area',
  area: 'Area',
  stackedArea: 'Stacked',
  normalizedArea: '100% Stacked',

  histogramChart: 'Histogram',
  histogramFrequency: 'Frequency',

  combinationChart: 'Combination',
  columnLineCombo: 'Column & Line',
  AreaColumnCombo: 'Area & Column',

  // Charts
  pivotChartTitle: 'Pivot Chart',
  rangeChartTitle: 'Range Chart',
  settings: 'Settings',
  data: 'Data',
  format: 'Format',
  categories: 'Categories',
  defaultCategory: '(None)',
  series: 'Series',
  xyValues: 'X Y Values',
  paired: 'Paired Mode',
  axis: 'Axis',
  navigator: 'Navigator',
  color: 'Color',
  thickness: 'Thickness',
  xType: 'X Type',
  automatic: 'Automatic',
  category: 'Category',
  number: 'Number',
  time: 'Time',
  autoRotate: 'Auto Rotate',
  xRotation: 'X Rotation',
  yRotation: 'Y Rotation',
  ticks: 'Ticks',
  width: 'Width',
  height: 'Height',
  length: 'Length',
  padding: 'Padding',
  spacing: 'Spacing',
  chart: 'Chart',
  title: 'Title',
  titlePlaceholder: 'Chart title - double click to edit',
  background: 'Background',
  font: 'Font',
  top: 'Top',
  right: 'Right',
  bottom: 'Bottom',
  left: 'Left',
  labels: 'Labels',
  size: 'Size',
  minSize: 'Minimum Size',
  maxSize: 'Maximum Size',
  legend: 'Legend',
  position: 'Position',
  markerSize: 'Marker Size',
  markerStroke: 'Marker Stroke',
  markerPadding: 'Marker Padding',
  itemSpacing: 'Item Spacing',
  itemPaddingX: 'Item Padding X',
  itemPaddingY: 'Item Padding Y',
  layoutHorizontalSpacing: 'Horizontal Spacing',
  layoutVerticalSpacing: 'Vertical Spacing',
  strokeWidth: 'Stroke Width',
  lineDash: 'Line Dash',
  offset: 'Offset',
  offsets: 'Offsets',
  tooltips: 'Tooltips',
  callout: 'Callout',
  markers: 'Markers',
  shadow: 'Shadow',
  blur: 'Blur',
  xOffset: 'X Offset',
  yOffset: 'Y Offset',
  lineWidth: 'Line Width',
  normal: 'Normal',
  bold: 'Bold',
  italic: 'Italic',
  boldItalic: 'Bold Italic',
  predefined: 'Predefined',
  fillOpacity: 'Fill Opacity',
  strokeOpacity: 'Line Opacity',
  histogramBinCount: 'Bin count',
  columnGroup: 'Column',
  barGroup: 'Bar',
  pieGroup: 'Pie',
  lineGroup: 'Line',
  scatterGroup: 'X Y (Scatter)',
  areaGroup: 'Area',
  histogramGroup: 'Histogram',
  combinationGroup: 'Combination',
  groupedColumnTooltip: 'Grouped',
  stackedColumnTooltip: 'Stacked',
  normalizedColumnTooltip: '100% Stacked',
  groupedBarTooltip: 'Grouped',
  stackedBarTooltip: 'Stacked',
  normalizedBarTooltip: '100% Stacked',
  pieTooltip: 'Pie',
  doughnutTooltip: 'Doughnut',
  lineTooltip: 'Line',
  groupedAreaTooltip: 'Area',
  stackedAreaTooltip: 'Stacked',
  normalizedAreaTooltip: '100% Stacked',
  scatterTooltip: 'Scatter',
  bubbleTooltip: 'Bubble',
  histogramTooltip: 'Histogram',
  columnLineComboTooltip: 'Column & Line',
  areaColumnComboTooltip: 'Area & Column',
  customComboTooltip: 'Custom Combination',
  noDataToChart: 'No data available to be charted.',
  pivotChartRequiresPivotMode:
    'Pivot Chart requires Pivot Mode enabled.',
  chartSettingsToolbarTooltip: 'Menu',
  chartLinkToolbarTooltip: 'Linked to Grid',
  chartUnlinkToolbarTooltip: 'Unlinked from Grid',
  chartDownloadToolbarTooltip: 'Download Chart',
  seriesChartType: 'Series Chart Type',
  seriesType: 'Series Type',
  secondaryAxis: 'Secondary Axis',

  // ARIA
  ariaChecked: 'checked',
  ariaColumn: 'Column',
  ariaColumnGroup: 'Column Group',
  ariaColumnList: 'Column List',
  ariaColumnSelectAll: 'Toggle Select All Columns',
  ariaDateFilterInput: 'Date Filter Input',
  ariaDefaultListName: 'List',
  ariaFilterColumnsInput: 'Filter Columns Input',
  ariaFilterFromValue: 'Filter from value',
  ariaFilterInput: 'Filter Input',
  ariaFilterList: 'Filter List',
  ariaFilterToValue: 'Filter to value',
  ariaFilterValue: 'Filter Value',
  ariaFilteringOperator: 'Filtering Operator',
  ariaHidden: 'hidden',
  ariaIndeterminate: 'indeterminate',
  ariaInputEditor: 'Input Editor',
  ariaMenuColumn: 'Press CTRL ENTER to open column menu.',
  ariaRowDeselect: 'Press SPACE to deselect this row',
  ariaRowSelectAll: 'Press Space to toggle all rows selection',
  ariaRowToggleSelection: 'Press Space to toggle row selection',
  ariaRowSelect: 'Press SPACE to select this row',
  ariaSearch: 'Search',
  ariaSortableColumn: 'Press ENTER to sort',
  ariaToggleVisibility: 'Press SPACE to toggle visibility',
  ariaUnchecked: 'unchecked',
  ariaVisible: 'visible',
  ariaSearchFilterValues: 'Search filter values',

  // ARIA Labels for Drop Zones

  ariaRowGroupDropZonePanelLabel: 'Row Groups',
  ariaValuesDropZonePanelLabel: 'Values',
  ariaPivotDropZonePanelLabel: 'Column Labels',
  ariaDropZoneColumnComponentDescription: 'Press DELETE to remove',
  ariaDropZoneColumnValueItemDescription:
    'Press ENTER to change the aggregation type',
  ariaDropZoneColumnGroupItemDescription: 'Press ENTER to sort',
  // used for aggregate drop zone, format: {aggregation}{ariaDropZoneColumnComponentAggFuncSeperator}{column name}
  ariaDropZoneColumnComponentAggFuncSeperator: ' of ',
  ariaDropZoneColumnComponentSortAscending: 'ascending',
  ariaDropZoneColumnComponentSortDescending: 'descending',

  // ARIA Labels for Dialogs
  ariaLabelColumnMenu: 'Column Menu',
  ariaLabelCellEditor: 'Cell Editor',
  ariaLabelDialog: 'Dialog',
  ariaLabelSelectField: 'Select Field',
  ariaLabelTooltip: 'Tooltip',
  ariaLabelContextMenu: 'Context Menu',
  ariaLabelSubMenu: 'SubMenu',
  ariaLabelAggregationFunction: 'Aggregation Function',

  // Number Format (Status Bar, Pagination Panel)
  thousandSeparator: ',',
  decimalSeparator: '.',
};

export default AG_GRID_LOCALE_FI;
